import { render, staticRenderFns } from "./DetailIndex.vue?vue&type=template&id=4d67706c&scoped=true"
import script from "./DetailIndex.vue?vue&type=script&lang=js"
export * from "./DetailIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d67706c",
  null
  
)

export default component.exports